import './burdoc/style';
import FormStructure from './burdoc/form_structure';

export default FormStructure;